import type { ReactNode } from 'react'

/**
 * Paylaşılan form ızgarası + alan sarmalayıcı (013 tasarım dili — FR-010). İki kolon responsive grid;
 * her alan label + zorunlu (*) + alan-altı hata. Kontrol (InputText/Dropdown/InputNumber/InputTextarea)
 * dışarıdan children olarak verilir. Reuse Mandate.
 */
export interface FormGridProps {
  children: ReactNode
}

export function FormGrid({ children }: Readonly<FormGridProps>) {
  return <div className="ui-form-grid">{children}</div>
}

export interface FormFieldProps {
  label: string
  /** İlişkili kontrolün id'si (label htmlFor). */
  htmlFor: string
  required?: boolean
  error?: string
  /** Alanı iki kolon boyunca genişletir (ör. textarea). */
  full?: boolean
  /** Etiketi görsel olarak gizler (`ui-sr-only`); erişilebilir ad ve `htmlFor` bağı kalır. */
  hideLabel?: boolean
  children: ReactNode
}

export default function FormField({
  label,
  htmlFor,
  required = false,
  error,
  full = false,
  hideLabel = false,
  children,
}: Readonly<FormFieldProps>) {
  return (
    <div className={`ui-field${full ? ' full' : ''}`}>
      <label className={hideLabel ? 'ui-field-label ui-sr-only' : 'ui-field-label'} htmlFor={htmlFor}>
        {label} {required && <span className="ui-req">*</span>}
      </label>
      {children}
      {/* Hata kutusu HER ZAMAN DOM'da, yalnız içeriği doluyor (THY inceleme bulgusu, 16.09.2026).
          Koşullu olarak EKLENEN bir `aria-live` bölgesi bazı ekran okuyucularda duyurulMAZ: bölgenin
          içerik gelmeden önce de var olması gerekir. `polite` seçildi — alan doğrulaması yazarken
          tetiklendiği için `assertive`/`role="alert"` kullanıcıyı sürekli böler.
          Boşken görsel ayak izi YOK: `.ui-field-err:empty` margin'i sıfırlar (ui.css).
          `id` türetilmiş: çağıran kontrole `aria-describedby={`${htmlFor}-err`}` verebilsin — kutuyu
          feature dosyalarında ELLE kurmak yerine buradan tüketmek Reuse Mandate'in gereği. */}
      <div className="ui-field-err" id={`${htmlFor}-err`} aria-live="polite">
        {error}
      </div>
    </div>
  )
}
